import React, { Dispatch, SetStateAction } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

import { UseOutletContextAccounting } from '../Accounting';
import { Company } from '../../../../models/company.model';
import { Settings } from '../../../../models/settings.model';

export interface VatReturnPageProps {};

type ContexType = {
  setRoute: Dispatch<SetStateAction<{path: {root: string, branch: string} | null, company: boolean} | null>>,
  companyForUser: Company | null,
  settingsForCompany: Settings | null
};

const VatReturnPage: React.FunctionComponent<VatReturnPageProps> = props => {
  const {setRoute, companyForUser, settingsForCompany} = UseOutletContextAccounting()

  return (
    <Outlet context={{setRoute, companyForUser, settingsForCompany}}></Outlet>
  );
}

export function UseOutletContextVatReturn() {
  return useOutletContext<ContexType>()
};

export default VatReturnPage;
